import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"stretch\"><a href=\"#stretch\"></a> Card Stretch </h1><div class=\"py-5\"> To have same height cards within <a href=\"\" class=\"\">Bootstrap</a> Grid use <code>.card-{mode}}</code> or responsive <code>.card-{breakpoint}-{mode}}</code> for <code>sm</code>, <code>md</code>, <code>lg</code>, <code>xl</code>, and <code>xxl</code>. </div><div class=\"py-5\"> Where <code>mode</code> is one of: <ul class=\"pt-3\"><li class=\"py-2\"><code>stretch</code> - for setting 100% stretch height </li><li class=\"py-2\"><code>stretch-75</code> - for setting 75% stretch height </li><li class=\"py-2\"><code>stretch-50</code> - for setting 50% stretch height </li><li class=\"py-2\"><code>stretch-33</code> - for setting 33.333% stretch height </li><li class=\"py-2\"><code>stretch-25</code> - for setting 25% stretch height </li></ul></div><div class=\"py-5\"><div class=\"row g-5\"><div class=\"col-lg-4\"><div class=\"card card-stretch shadow mb-5\"><div class=\"card-header\"><h3 class=\"card-title\">Height 100%</h3></div><div class=\"card-body\"> Lorem Ipsum is simply dummy text </div><div class=\"card-footer\"> Footer </div></div></div><div class=\"col-lg-4\"><div class=\"card card-stretch-50 shadow mb-5\"><div class=\"card-header\"><h3 class=\"card-title\">Height 50%</h3></div><div class=\"card-body\"> Lorem Ipsum is simply dummy text </div><div class=\"card-footer\"> Footer </div></div><div class=\"card card-stretch-50 shadow mb-5\"><div class=\"card-header\"><h3 class=\"card-title\">Height 50%</h3></div><div class=\"card-body\"> Lorem Ipsum is simply dummy text </div><div class=\"card-footer\"> Footer </div></div></div><div class=\"col-lg-4\"><div class=\"card card-stretch-33 shadow mb-5\"><div class=\"card-header\"><h3 class=\"card-title\">Height 33.333%</h3></div><div class=\"card-body\"> Lorem Ipsum is simply dummy text </div><div class=\"card-footer\"> Footer </div></div><div class=\"card card-stretch-33 shadow mb-5\"><div class=\"card-header\"><h3 class=\"card-title\">Height 33.333%</h3></div><div class=\"card-body\"> Lorem Ipsum is simply dummy text </div><div class=\"card-footer\"> Footer </div></div><div class=\"card card-stretch-33 shadow mb-5\"><div class=\"card-header\"><h3 class=\"card-title\">Height 33.333%</h3></div><div class=\"card-body\"> Lorem Ipsum is simply dummy text </div><div class=\"card-footer\"> Footer </div></div></div></div></div>", 4)
const _hoisted_6 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_CodeHighlighter, {
        fieldHeight: 500,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="row g-5">
          <div class="col-lg-4">
            <div class="card card-stretch shadow mb-5">
              <div class="card-header">
                <h3 class="card-title">Height 100%</h3>
              </div>
              <div class="card-body">
                Lorem Ipsum is simply dummy text
              </div>
              <div class="card-footer">
                Footer
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="card card-stretch-50 shadow mb-5">
              <div class="card-header">
                <h3 class="card-title">Height 100%</h3>
              </div>
              <div class="card-body">
                Lorem Ipsum is simply dummy text
              </div>
              <div class="card-footer">
                Footer
              </div>
            </div>

            <div class="card card-stretch-50 shadow mb-5">
              <div class="card-header">
                <h3 class="card-title">Height 100%</h3>
              </div>
              <div class="card-body">
                Lorem Ipsum is simply dummy text
              </div>
              <div class="card-footer">
                Footer
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="card card-stretch-33 shadow mb-5">
              <div class="card-header">
                <h3 class="card-title">Height 33.333%</h3>
              </div>
              <div class="card-body">
                Lorem Ipsum is simply dummy text
              </div>
              <div class="card-footer">
                Footer
              </div>
            </div>

            <div class="card card-stretch-33 shadow mb-5">
              <div class="card-header">
                <h3 class="card-title">Height 33.333%</h3>
              </div>
              <div class="card-body">
                Lorem Ipsum is simply dummy text
              </div>
              <div class="card-footer">
                Footer
              </div>
            </div>

            <div class="card card-stretch-33 shadow mb-5">
              <div class="card-header">
                <h3 class="card-title">Height 33.333%</h3>
              </div>
              <div class="card-body">
                Lorem Ipsum is simply dummy text
              </div>
              <div class="card-footer">
                Footer
              </div>
            </div>
          </div>
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}